export default "__VITE_ASSET__BWc7TNzj__"